import {
  IActionPlan,
  IActionPlanUser,
} from '../components/EditActionPlan/interfaces/actionPlan';

export function actionPlanAssignedUser (
  actionPlan: IActionPlan
): IActionPlanUser {
  if (actionPlan.assignedUsers && actionPlan.assignedUsers.length) {
    return actionPlan.assignedUsers[0];
  } else {
    return actionPlan.assigned;
  }
}
